import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import TechStack from './components/TechStack';
import Projects from './components/Projects';
import CodingProfiles from './components/CodingProfiles';
import Contact from './components/Contact';
import './App.css';

function App() {
  // Dark/light theme toggle
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <>
      <Navbar theme={theme} setTheme={setTheme} />
      <main>
        <section id="home" className="section"><Home /></section>
        <section id="techstack" className="section bg-light"><TechStack /></section>
        <section id="projects" className="section"><Projects /></section>
        <section id="coding" className="section bg-light"><CodingProfiles /></section>
        <section id="contact" className="section"><Contact /></section>
      </main>
    </>
  );
}

export default App;
